import React, { Component } from 'react'
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import dictCache from '../../../../common/dictCache';
import FomeList from './FomeList';
import { Button, message } from 'antd';
import FeferenceQuote from './FeferenceQuote';
import SubjectsVisitsNumber from './SubjectsVisitsNumber';


export default class ForecastParams extends Component {
    state = {
        params: {},
        type: "view",
        targetList: [], //靶点
        tumorTreatMethodList: [], //肿瘤治疗方式
        medicationFrequencyList:[], //来院用药频率
        medicationNumberList: [], //药物数量
        medicationFrequencyOption: [],  //来院用药频率选项
        areaList: [], // 治疗领域
        diseaseClassList: [], // 疾病分类列表
        diseaseList: [], // 疾病列表
        submitDisabled: false,
        researchProductTypeList: [], // 研究产品类型列表
    };

    componentDidMount() {
        const { evaluateRecordId } = this.props;
        this.loadData(evaluateRecordId)
        this.queryTarget()
        this.queryTumorTreatMethodList()
        this.queryMedicationFrequencyList()
        this.queryMedicationNumberList()
        this.queryConfigWithChildByType()
    }

    componentWillReceiveProps(nextProps) {
        const { evaluateRecordId } = nextProps;
        const { params: { evaluateRecordId: oldEvaluateRecordId} } = this.state;
        if(evaluateRecordId != oldEvaluateRecordId) {
            this.loadData(evaluateRecordId)
        }
    }
    //研究产品类型选项
    queryConfigWithChildByType = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_RESEARCH_PRODUCT_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { list = [] } = res;
            const newList = list.map(el => ({
                value: el.evaluateConfigureId,
                code: el.code,
                label: el.configureValue,
                children: el.childList.length ? el.childList.map(childData => ({
                    value: childData.evaluateConfigureId,
                    label: childData.configureValue,
                })) : undefined,
            }));
            this.setState({ researchProductTypeList: newList });
        });
    }

    //获取项目领域列表
    loadAreaList = () => {
        return new Promise((resolve, reject) => {
            dictCache.getDict('TYPE_CONFIGURE', cb => {
                $.sendRequest({
                    method: 'POST',
                    url: API_URL.common.typeConfigureList,
                    data: {},
                    dataType: 'json',
                    doneResult: res => cb(res),
                    failResult: (err) => {
                        reject(err);
                    },
                });
            }, res => {
                this.setState({
                    areaList: res.areaList || []
                }, () => resolve(res));
            });
        });
    }
    //获取疾病分类列表
    loadDiseaseClassList = (investigationAreaId) => {
        return new Promise((resolve, reject) => {
            const options = {
                method: 'POST',
                url: API_URL.common.queryDiseaseClassByAreaId,
                data: { investigationAreaId: investigationAreaId ? investigationAreaId : undefined},
                dataType: 'json',
                doneResult: res => {
                    this.setState({
                        diseaseClassList: res.diseaseClassList || []
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            }
            $.sendRequest(options);
        });
    }
    //获取疾病列表
    loadDiseaseList = () => {
        return new Promise((resolve, reject) => {
            const options1 = {
            method: 'POST',
                url: API_URL.common.queryAllDisease,
                data: {},
                dataType: 'json',
                doneResult: res => {
                    this.setState({
                        diseaseList: res.data || []
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            }
            $.sendRequest(options1);
        });
    }
    //获取参考标准访视单价
    loadStandardVisitAmount = (data) => {
        this.setState({
            submitDisabled: true,
        })
        const options = {
            method: 'POST',
            url: API_URL.evaluate.standardVisitAmount,
            data,
            dataType: 'json',
            doneResult: res => {
                let standardVisitUnitPrice = res.evaluateStandardVisitUnitPrice && res.evaluateStandardVisitUnitPrice.originalUnitPrice || 0;
                // 使用函数式setState确保基于最新的state进行更新
                this.setState(prevState => ({
                    params: {
                        ...prevState.params,
                        standardVisitUnitPrice,
                    },
                    submitDisabled: false
                }));
            },
            failResult: (err) => {
                this.setState({
                    submitDisabled: false,
                })
            }
        }
        $.sendRequest(options)
    }

    loadData = (evaluateRecordId) => {
        if(!evaluateRecordId) return
        const options = {
            method: 'POST',
            url: API_URL.evaluate.viewEvaluateRecordCalculate,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: async (res) => {
                const { evaluateRecordCalculate = {}, evaluateRecordCalculateExternal } = res
                const { treatGroupList = [], followTheStageHour, followTheClinicHour, investigationAreaId, diseaseClassId, diseaseId, researchProductTypeId, productTypeParentId, researchProductTypeName, calAreaDiseaseShow } = evaluateRecordCalculate;
                const joinVisitGroupingList = [];
                const newTreatGroupList = [];

                let joinRandomCaseNum = 0;
                treatGroupList.map((el, index) => {
                    const { cycleShow, hospitalMedicationFrequencyShow, routeList, customFrequency, treatmentPeriodFrequencyShow } = el;
                    el.groupName = `治疗组别${index + 1}`
                    el.groupIndex = index;
                    el.cycleRangeShow = customFrequency ? customFrequency : ((cycleShow && hospitalMedicationFrequencyShow) ? `${cycleShow}(${hospitalMedicationFrequencyShow})` : '');
                    const len = (routeList || []).length;
                    if (len) {
                        routeList.forEach((route, routeIndex) => {
                            const { 
                                evaluateHospitalMedicationFrequencyOptimize = {},
                            } = route;
                        if (this.isWorthObj(evaluateHospitalMedicationFrequencyOptimize)) {
                            newTreatGroupList.push({
                                ...el,
                                ...route,
                                ...evaluateHospitalMedicationFrequencyOptimize,
                                rowSpan: routeIndex === 0 ? len : 0,
                                rowId: `${el.evaluateRecordCalculateTreatGroupId}-${route.routeId}`
                            })
                        } else {
                            newTreatGroupList.push({
                                ...el,
                                ...route,
                                visitCycleShow: cycleShow,
                                medicationCycleShow: hospitalMedicationFrequencyShow,
                                medicationShow: treatmentPeriodFrequencyShow,
                                rowSpan: routeIndex === 0 ? len : 0,
                                rowId: `${el.evaluateRecordCalculateTreatGroupId}-${route.routeId}`
                            })
                        }
                        });
                    } else {
                        newTreatGroupList.push({
                            ...el,
                            rowSpan: 1,
                            rowId: el.evaluateRecordCalculateTreatGroupId
                        });
                    }

                    if (el.joinVisitGrouping == '1') {
                        joinVisitGroupingList.push(el.groupName);
                        if (el.randomCaseNum) {
                            joinRandomCaseNum = joinRandomCaseNum + el.randomCaseNum;
                        }
                    }
                })

                const subjectsVisitsNumber = <a onClick={() => this.SubjectsVisitsNumberRef.show(evaluateRecordId)}>数据分析查看</a>;
                
                // 如果有investigationAreaId，从areaList匹配对应的investigationAreaName
                let investigationAreaName = '';
                // if (investigationAreaId) {
                    // 使用Promise方式等待areaList加载完成
                    const res1 = await this.loadAreaList();
                    if (res1 && res1.areaList && res1.areaList.length > 0 && investigationAreaId) {
                        const matchedArea = res1.areaList.find(area => area.investigationAreaId == investigationAreaId);
                        if (matchedArea) {
                            investigationAreaName = matchedArea.investigationAreaName || '';
                        }
                    }
                // }
                let diseaseClassName = '';
                // 如果有diseaseClassId，从diseaseClassList匹配对应的diseaseClassName
                if (diseaseClassId) {
                    // 使用Promise方式等待diseaseClassList加载完成
                    const res = await this.loadDiseaseClassList(investigationAreaId);
                    if (res && res.data && res.data.length > 0) {
                        const matchedDiseaseClass = res.data.find(diseaseClass => diseaseClass.diseaseClassId == diseaseClassId);
                        if (matchedDiseaseClass) {
                            diseaseClassName = matchedDiseaseClass.diseaseClassName || '';
                        }
                    }
                }
                let diseaseName = '';
                // 如果有diseaseId，从diseaseList匹配对应的diseaseName
                if (diseaseId) {
                    // 使用Promise方式等待diseaseList加载完成
                    const res = await this.loadDiseaseList();
                    if (res && res.data && res.data.length > 0) {
                        const matchedDisease = res.data.find(disease => disease.diseaseId == diseaseId);
                        if (matchedDisease) {
                            diseaseName = matchedDisease.diseaseName || '';
                        }
                    }
                }

                this.setState({
                    params: {
                        evaluateRecordId,
                        ...evaluateRecordCalculate,
                        treatGroupList: newTreatGroupList,
                        followTheStageDay: followTheStageHour ? (followTheStageHour / 8).toFixed(2) : 0,
                        followTheClinicDay: followTheClinicHour ? (followTheClinicHour / 8).toFixed(2) : 0,
                        ...evaluateRecordCalculateExternal,
                        subjectsVisitsNumber,
                        joinVisitGroupingShow: joinVisitGroupingList.join(','),
                        joinRandomCaseNum,
                        diseaseClassName,
                        diseaseName,
                        // referenceStandardVisitUnitPrice: (researchProductTypeName && `${researchProductTypeName}`) + (investigationAreaName && `-${investigationAreaName}`) + (diseaseClassName && `-${diseaseClassName}`) + (diseaseName && `-${diseaseName}`),
                        referenceStandardVisitUnitPrice: calAreaDiseaseShow,
                        researchProductTypeId: productTypeParentId == 0 ? [researchProductTypeId] : [productTypeParentId, researchProductTypeId],
                    }
                })
            }
        };
        $.sendRequest(options);
    }

    isWorthObj = (obj) => {
        // 先验证输入是否为对象（排除null/数组等）
        if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
            return false;
        }
        return Object.keys(obj).length !== 0;
    }

    queryTarget = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryTargetPointsList,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const data = res.datas.map(item => ({
                    text: item.targetName,
                    value: String(item.evaluateTargetPointsId),
                    fetching: false,
                }));
                this.setState({
                    targetList: data,
                });
            }
        };
        $.sendRequest(options);
    }

    queryTumorTreatMethodList = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryTumorTreatMethodList,
            data: { limit: 9999 },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    tumorTreatMethodList: res.datas,
                });
            }
        };
        $.sendRequest(options);
    }

    
    queryMedicationFrequencyList = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryMedicationFrequencyList,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { medicationFrequencyList } = this.state;
                (res.datas || []).map(el => {
                    const { cycleShow, rangeShow } = el;
                    medicationFrequencyList.push({
                        ...el,
                        cycleRangeShow: `${cycleShow}(${rangeShow})`,
                    })
                })
                this.setState({
                    medicationFrequencyList,
                });
            }
        };
        $.sendRequest(options);
    }

    queryMedicationNumberList = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryMedicationNumberList,
            data: { },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    medicationNumberList: res.datas,
                });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params: currentParams } = this.state;
        const { evaluateRecordId } = this.props;
        
        // 创建params的副本，使用不可变更新方式
        const params = { ...currentParams };
        params[key] = value;
        
        switch (key) {
            case 'targetIds': {
                params[key] = value.map(el => (el.key)).join(',');
                params.targetNames = value.map(el => {
                    const { label } = el;
                    if(typeof label === 'string') {
                        return el.label
                    }else if(typeof label === 'object') {
                        return el.label.props.title
                    }
                }).join('；');
                break;
            }
            case 'followTheStageHour' : {
                params.followTheStageDay = value ? (value / 8).toFixed(2) : 0;
                break
            }
            case 'followTheClinicHour': {
                params.followTheClinicDay = value ? (value / 8).toFixed(2) : 0;
                break
            }
            case 'preFilterServeSiteNum':
            case 'preFilterPeriod':
            case 'singleSitePreFilterHour': {
                if (params.preFilterServeSiteNum && params.preFilterPeriod && params.singleSitePreFilterHour) {
                    params.preFilterHour = Number((params.preFilterServeSiteNum * params.preFilterPeriod * params.singleSitePreFilterHour).toFixed(2));
                } else {
                    params.preFilterHour = 0;
                }
                break
            }
            case 'joinVisitGroupingShow':
                if (value) {
                    let sumValue = 0;
                    (params.treatGroupList || []).map(treatGroup => {
                        if (value.includes(treatGroup.groupName)) {
                            if (treatGroup.rowSpan > 0) {
                                sumValue = sumValue + (treatGroup.randomCaseNum || 0);
                            }
                            treatGroup.joinVisitGrouping = '1';
                        } else {
                            treatGroup.joinVisitGrouping = '0';
                        }
                    });
                    params.joinRandomCaseNum = sumValue;
                } else {
                    params.joinRandomCaseNum = undefined;
                }
                break;
            case 'researchProductTypeId': {
                this.loadStandardVisitAmount({
                    researchProductTypeId: params.researchProductTypeId[params.researchProductTypeId.length - 1],
                    investigationAreaId: params.investigationAreaId || '',
                    diseaseClassId: params.diseaseClassId || '',
                    diseaseId: params.diseaseId || '',
                    evaluateRecordId: evaluateRecordId,
                });
                break
            }
            case 'investigationAreaId': {
                params.diseaseClassId = undefined;
                params.diseaseClassName = undefined;
                params.diseaseId = undefined;
                params.diseaseName = undefined;
                this.loadStandardVisitAmount({
                    researchProductTypeId: params.researchProductTypeId[params.researchProductTypeId.length - 1],
                    investigationAreaId: params.investigationAreaId,
                    evaluateRecordId: evaluateRecordId,
                });
                break
            }
            case 'diseaseClassId': {
                if(JSON.stringify(value) === '{}') {
                    params.diseaseClassId = '0';
                    params.diseaseClassName = '-';
                }else{
                    const { value: id, text } = value;
                    params.diseaseClassId = id;
                    params.diseaseClassName = text;
                }
                params.diseaseId = undefined;
                params.diseaseName = undefined;
                this.loadStandardVisitAmount({
                    researchProductTypeId: params.researchProductTypeId[params.researchProductTypeId.length - 1],
                    investigationAreaId: params.investigationAreaId,
                    diseaseClassId: params.diseaseClassId,
                    evaluateRecordId: evaluateRecordId,
                });
                break
            }
            case 'diseaseId': {
                if(JSON.stringify(value) === '{}') {
                    params.diseaseId = '0';
                    params.diseaseName = '-';
                }else{
                    const { value: id, text } = value;
                    params.diseaseId = id;
                    params.diseaseName = text;
                }
                if(params.investigationAreaId) {
                    this.loadStandardVisitAmount({
                        researchProductTypeId: params.researchProductTypeId[params.researchProductTypeId.length - 1],
                        investigationAreaId: params.investigationAreaId,
                        diseaseClassId: params.diseaseClassId,
                        diseaseId: params.diseaseId,
                        evaluateRecordId: evaluateRecordId,
                    });
                }
                break
            }
        }
        this.setState({ params });
    };

    // 处理medicationNumber修改
    handleMedicationNumberChange = (newValue, record, index) => {
        
        const { params } = this.state;
        const row = {
            ...record,
            // randomCaseNum: 0,
            routeId: undefined,
            routeName: undefined,
            routeType: undefined,
            drugName: undefined,
            visitCycleShow: undefined,
            visitCycleCount: undefined,
            visitCycleType: undefined,
            medicationCycleShow: undefined,
            medicationCycleCount: undefined,
            medicationCycleType: undefined,
            medicationShow: undefined,
            rowSpan: 0,
        }
        // 1. 边界校验：新值必须≥1，非合并首行（rowSpan=0）不处理
        if (!newValue || newValue < 1 || record.rowSpan === 0) {
            return;
        }
        

        // 2. 复制数据源（不可变更新）
        const newDataSource = [...params.treatGroupList];
        // 旧值 = 合并首行的rowSpan（原medicationNumber）
        const oldValue = record.rowSpan;
        // 计算差值：新值 - 旧值
        const diff = newValue - oldValue;

        // 差值为0无需处理
        if (diff === 0) return;

        // 3. 确定合并组范围：首行索引 → 首行索引+旧值-1
        const groupStartIdx = index;
        const groupEndIdx = groupStartIdx + oldValue - 1;

        // 4. 同步合并组内所有行的medicationNumber为新值
        for (let i = groupStartIdx; i <= groupEndIdx; i++) {
            if (newDataSource[i]) {
                newDataSource[i].medicationNumber = newValue;
            }
            }

            // 5. 处理行的新增/删除
            if (diff > 0) {
            // 差值为正：新增diff行（空白行），插入到合并组末尾
            const addRows = Array(diff)
                .fill(null)
                .map(() => (row));
            // 插入到合并组最后一行的下一个位置
            newDataSource.splice(groupEndIdx + 1, 0, ...addRows);
        } else {
        // 差值为负：删除Math.abs(diff)行（从合并组末尾删，保留首行）
            const deleteCount = Math.abs(diff);
            // 计算删除起始索引（确保不删首行）
            const deleteStartIdx = groupEndIdx - deleteCount + 1;
            const safeDeleteStartIdx = Math.max(deleteStartIdx, groupStartIdx + 1); // 首行（groupStartIdx）不删
            // 实际删除行数（避免负数）
            const actualDeleteCount = Math.min(deleteCount, groupEndIdx - safeDeleteStartIdx + 1);
            
            if (actualDeleteCount > 0) {
                newDataSource.splice(safeDeleteStartIdx, actualDeleteCount);
            }
        }
        newDataSource[groupStartIdx].rowSpan = newValue;
        params.treatGroupList = newDataSource;
        this.setState({ params });
    }

    handleTableChange = (value, key, index) => {
        const { params, medicationNumberList, medicationFrequencyList } = this.state;
        params.treatGroupList[index][key] = value;
        switch (key) {
            case 'medicationNumberId': {
                params.treatGroupList[index].medicationNumber = value ? 
                    medicationNumberList.find(el => el.evaluateMedicationNumberId == value).medicationNumber : 0;
                    
                    this.handleMedicationNumberChange(
                        params.treatGroupList[index].medicationNumber,
                        params.treatGroupList[index],
                        index,
                    );
                    break;
                }
            // case 'routeId': {
            //     const { routeIds, routeNames } = value;
            //     delete params.treatGroupList[index].route
            //     params.treatGroupList[index].routeIds = routeIds;
            //     params.treatGroupList[index].routeNames = routeNames;
            //     break;
            // }
            case 'hospitalMedicationFrequencyId':
                const { label } = (value || {});
                delete params.treatGroupList[index].hospitalMedicationFrequencyId
                medicationFrequencyList.map(el => {
                    if (el.cycleRangeShow == label) {
                        params.treatGroupList[index].hospitalMedicationFrequencyId = el.evaluateHospitalMedicationFrequencyId;
                    }
                });
                params.treatGroupList[index].customFrequency = label;
                break;
            case 'randomCaseNum':
                let joinRandomCaseNum = 0;
                params.treatGroupList.map(el => {
                    if (el.joinVisitGrouping == '1') {
                        if (el.rowSpan > 0 && el.randomCaseNum) {
                            joinRandomCaseNum = joinRandomCaseNum + el.randomCaseNum;
                        }
                    }
                });
                params.joinRandomCaseNum = joinRandomCaseNum;
                break;
        }
        this.setState({ params });
    };

    handleMedicationSituationChange = (updates) => {
        this.setState(function(prevState) {
            // 1. 拷贝params外层（React 15兼容：用Object.assign替代...）
            const newParams = Object.assign({}, prevState.params);
            
            // 2. 拷贝treatGroupList数组 + 每个元素（彻底断开引用）
            newParams.treatGroupList = prevState.params.treatGroupList.map(function(item) {
            return Object.assign({}, item); // 替代{...item}
            });

            // 3. 处理批量更新
            if (Array.isArray(updates)) {
            updates.forEach(function(update) {
                const index = update.index;
                const key = update.key;
                const value = update.value;
                // React 15兼容：短路判断，避免访问undefined的属性
                if (newParams.treatGroupList && newParams.treatGroupList[index]) {
                newParams.treatGroupList[index][key] = value;
                }
            });
            }
            // 兼容单条更新（可选）
            else if (updates.index !== undefined && updates.key) {
            const index = updates.index;
            const key = updates.key;
            const value = updates.value;
            if (newParams.treatGroupList && newParams.treatGroupList[index]) {
                newParams.treatGroupList[index][key] = value;
            }
            }

            return { params: newParams };
        });
    };

    submit = () => {
        const { params } = this.state;
        const queryData = JSON.parse(JSON.stringify(params));
        const Config = this.handleDomRender();
        try {
            Config.map(el => {
                const { name, label, type, required = false, show = true } = el;
                if(required && show) {
                    if(type === 'InputNumber') {
                        if( queryData[name] === undefined || queryData[name] === null || queryData[name] === '' ) {
                            throw label
                        }
                    } else if(type === 'Table') {
                        if( !queryData[name] ) {
                            throw label
                        }else {
                            const { typeProperty: { columns } } = el;
                            queryData[name].map(item => {
                                columns.map(column => {
                                    const { title, tebleItemKey, required } = column;

                                    if( required && (item[tebleItemKey] === undefined ||  item[tebleItemKey] === null ||  item[tebleItemKey] === '' )) {
                                        if (tebleItemKey == 'hospitalMedicationFrequencyId') {
                                            if( item['customFrequency'] === undefined ||  item['customFrequency'] === null ||  item['customFrequency'] === '' ) {
                                                throw `${item.groupName}的${title}` 
                                            }
                                        } else {
                                            throw `${item.groupName}的${title}` 
                                        }
                                    }
                                })
                            })
                        }
                    } else if(type==='customize'){
                        if( queryData.researchProductTypeId === undefined || queryData.researchProductTypeId === null || queryData.researchProductTypeId === '' || (queryData.researchProductTypeId && queryData.researchProductTypeId.length === 0)
                         ) {
                            throw label
                        }
                    } else {
                        if( !queryData[name] ) {
                            throw label
                        }
                    }
                }
            })
        } catch (error) {
            message.warning(`请填写${error}！`);
            return false
        }
        const { treatGroupList, evaluateRecordId } = queryData;
        // 若访视组别删除的是中间或开始位置，需要重新映射 groupIndex ，保持原来的分组关系不变，但序号从 0 开始连续递增。 
        // 1. 按原始 groupIndex 分组，建立映射表
        const groupedObj = treatGroupList.reduce((acc, item) => {
            const key = item.groupIndex;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});
        
        // 2. 建立原始 groupIndex 到新 groupIndex 的映射关系 (0, 1, 2, ...)
        const groupIndexMap = {};
        Object.keys(groupedObj).forEach((key, index) => {
            groupIndexMap[key] = index;
        });
        
        // 3. 重新分配 groupIndex，从 0 开始递增，保持分组关系不变
        treatGroupList.forEach(item => {
            item.groupIndex = groupIndexMap[item.groupIndex];
        });
        
        // 添加 routeIndex 
        const List = treatGroupList.reduce((acc, item, index) => {
            // 获取上一个元素的 groupIndex（初始为 undefined）
            const lastGroup = acc.length > 0 ? acc[acc.length - 1].groupIndex : undefined;
            // 计算当前 routeIndex：同分组则+1，不同分组则重置为 0
            const routeIndex = item.groupIndex === lastGroup ? acc[acc.length - 1].routeIndex + 1 : 0;
            // 往结果数组添加新对象（不修改原数据）
            acc.push({ ...item, routeIndex });
            return acc;
        }, []);

        List.map((el, index) => {
            delete el.routeList
            delete el.evaluateHospitalMedicationFrequencyOptimize
            const groupKeyArr = [
                'customFrequency', 
                'cycleRangeShow', 
                'evaluateRecordCalculateId',
                'evaluateRecordCalculateRouteId',
                'evaluateRecordCalculateTreatGroupId',
                'customTreatmentPeriodFrequency',
                'id',
                'joinVisitGrouping',
                'medicationCount',
                'medicationNumber',
                'medicationNumberId',
                'medicationNumberName',
                'randomCaseNum',
                'rowId',
                'veinNum',
                'visitGroupingId',
                'visitGroupingName'
            ];
            const routeKeyArr = [
                'routeType', 
                'routeId', 
                'routeName', 
                'drugName', 
                'visitCycleShow', 
                'medicationCycleShow', 
                'medicationShow', 
                'visitCycleCount', 
                'visitCycleType', 
                'medicationCycleCount', 
                'medicationCycleType', 
                'evaluateHospitalMedicationFrequencyOptimizeId'
            ];
            if (el.rowSpan > 0) { 
                groupKeyArr.map(groupKey => {
                    queryData[`treatGroupList[${el.groupIndex}].${groupKey}`] = el[groupKey];
                })
            }

            routeKeyArr.map(routeKey => {
                queryData[`treatGroupList[${el.groupIndex}].routeList[${el.routeIndex}].${routeKey}`] = el[routeKey];
            })
            
        });

        delete queryData.targetList
        delete queryData.treatGroupList
        delete queryData.diseaseClassName
        delete queryData.diseaseName
        const options = {
            method: 'POST',
            url: API_URL.evaluate.updateEvaluateRecordCalculate,
            data: {
                ...queryData,
                // standardVisitUnitPrice,
                researchProductTypeId: queryData.researchProductTypeId[queryData.researchProductTypeId.length - 1],
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    type: 'view',
                },() => this.loadData(evaluateRecordId));
            }
        };
        $.sendRequest(options);
    }

    parseCycleRangeData = (res, value) => {
        if (res.datas) {
            const data = (res.datas || []).map(el => ({
                text: `${el.cycleShow}(${el.rangeShow})`,
                value: `${el.cycleShow}(${el.rangeShow})`,
            }));
            this.setState({ medicationFrequencyOption: data });
        } else {
            this.setState({ medicationFrequencyOption: [] });
        }
    }

    parseInvProceedData = (res, key, text, value) => {
        const stateObj = {};
        if ((res.datas)) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: item[text],
                value: String(item[value]),
                fetching: false,
            }));
            stateObj[key] = data;
        } else {
            stateObj[key] = [];
        }
        this.setState({ ...stateObj });
    }
    handleDomRender = () => {
        const { record } = this.props;
        const {
            pmlAuth,  //PML
            pmAuth,  //PM
            talAuth,  //领域leader
            deptBoAuth,  //部门BO
            seniorUserAuth,  //王总
            lineOfBusinessString,   //业务线
            researchProductTypeName,   //此研究产品类型历史入组速率值tip
        } = record;
        const { 
            params:{
                canEditTumorTreatMethod,
                isNeedEngravingUpload,
                hasIntensivePkBlood,
                isFollowTheStage,
                followTheStageDay,
                hasFollowTheClinic,
                followTheClinicDay,
                canEditPmAverageMonthFte,
                canEditDblAverageMonthFte,
                canEditCloseSiteAverageMonthFte,
                canEditUnblindedAverageMonthFte,
                canEditUnblindedPmAverageMonthFte,
                canEditPreFilterHour,
                showStartSiteServeUnitPrice,
                showPmProjectManagerFtePercent,
                showCloseSiteUnitPrice,
                showDblUnitVisitHour,
                showStartGeneticLeadingUnitPrice,
                showGeneticNonLeadingUnitPrice,
                showCollectAndApproveUnitPrice,
                showDataBackupFilingUnitPrice,
                showInternationalCooperationApprovalUnitPrice,
                showInternationalCooperationFilingUnitPrice,
                showInternationalCooperationChangesUnitPrice,
                showMaterialExportApprovalUnitPrice,
                showPreservationApprovalUnitPrice,
                showStartPhaseUnitPrice,
                showInGroupPhaseUnitPrice,
                showTreatmentPeriodUnitPrice,
                showFollowUpPeriodUnitPrice,
                canEditCoordinatePathologicalSectionsCount,
                haveResearchCycle,
                haveInvManagerServe,
                haveSiteStartServe,
                haveGeneticOfficeLead,
                treatGroupList,
                investigationAreaId,
                diseaseClassId,
            },
            targetList,
            tumorTreatMethodList,
            medicationNumberList,
            medicationFrequencyList,
            medicationFrequencyOption,
            areaList,
            type,
            researchProductTypeList,
        } = this.state;
        const tumorTreatMethodOption = tumorTreatMethodList.map(el => ({ label: el.treatMethod, value: el.evaluateTumorTreatMethodId }));
        const medicationNumberOption = medicationNumberList.map(el => ({ label: el.medicationNumberName, value: el.evaluateMedicationNumberId }));
        const treatGroupOption = (treatGroupList || []).map(el => ({ label: el.groupName, value: el.groupName }));
        const yseOrNo = [
            { label: '是', value: '1' },
            { label: '否', value: '0' },
        ];
        let areaOption = areaList.map(el => ({ label: el.investigationAreaName, value: el.investigationAreaId }))
        // areaOption.push({ label: '-', value: 0 }); //治疗领域
        const Config = [
            {
                label: '项目参数',
                type: 'Title',
            },
            {
            label: '靶点',
            name: 'targetIds',
            showName: 'targetNames',
            type: 'SearchMulSelect',
            required: true,
            typeProperty: {
                keyword: 'targetName',
                style: { width: 200 },
                url: API_URL.evaluate.queryTargetPointsList,
                sourceData: targetList,
                searchParam: { limit: 20 },
                parseData: res => this.parseInvProceedData(res, 'targetList', 'targetName', 'evaluateTargetPointsId'),
            },
        }, 
        {
            label: '肿瘤治疗方式',
            name: 'tumorTreatMethodId',
            showName: 'tumorTreatMethod',
            type: 'Select' ,
            show: lineOfBusinessString == '肿瘤',
            required: canEditTumorTreatMethod,
            canEdit: canEditTumorTreatMethod,
            typeProperty: {
                style: { width: 200 },
                placeholder: '请输入检索',
                option: tumorTreatMethodOption,
                filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
                showSearch: true,
            },
        }, 
        {
            label: '项目速率信息',
            type: 'Title',
        },
        {
            label: '此领域历史入组速率值',
            name: 'lineAreaInGroupRate',
            show: talAuth || deptBoAuth || pmlAuth || pmAuth || seniorUserAuth,
            type: 'text',
        }, {
            label: '此疾病历史入组速率值',
            name: 'diseaseInGroupRate',
            show: talAuth || deptBoAuth || pmlAuth || pmAuth || seniorUserAuth,
            type: 'text',
        }, {
            label: '此靶点历史入组速率值',
            name: 'targetInGroupRate',
            show: talAuth || deptBoAuth || pmlAuth || pmAuth || seniorUserAuth,
            type: 'text',
        }, {
            label: '此研究产品类型历史入组速率值',
            name: 'productInGroupRate',
            show: talAuth || deptBoAuth || pmlAuth || pmAuth || seniorUserAuth,
            type: 'text',
            tipTitle: researchProductTypeName,
        }, {
            label: '此项目入组速率预估',
            name: 'smoPredicatedAverageInGroupRate',
            type: 'InputNumber',
            required: true,
            unit: 'pts/site/m',
            typeProperty: {
                precision: 2,
                style: {
                    width: '60%',
                }
            },
        }, {
            label: 'Planned LPO Date',
            name: 'plannedLpoDate',
            type: 'text',
        }, {
            label: '客户参数预测平均入组速率预测',
            name: 'customerPredictedAverageInGroupRate',
            type: 'InputNumber',
            type: 'text',
        }, 
        {
            label: '访视方案',
            type: 'Title',
        },
        {
            label: '参与此项目随机病例数统计的访视方案',
            name: 'joinVisitGroupingShow',
            showName: 'joinVisitGroupingShow',
            type: 'SelectMultiple' ,
            required: true,
            typeProperty: {
                style: { width: 200 },
                placeholder: '请选择',
                mode: 'multiple',
                option: treatGroupOption,
            },
        },
        {
            label: '此项目随机病例数',
            name: 'randomCaseNum',
            type: 'text',
        },
        {
            label: '此项目参与统计的访视方案随机病例数',
            name: 'joinRandomCaseNum',
            type: 'text',
        },
        {
            label: '',
            name: 'treatGroupList',
            type: 'Table',
            required: true,
            typeProperty: {
                canDel: true,
                columns: [{
                    title: '组别',
                    tebleItemKey: 'groupName',
                    type: 'text',
                    shouldRowSpan: true,
                    width: 80,
                }, {
                    title: '访视方案名称',
                    tebleItemKey: 'visitGroupingName',
                    type: 'Input',
                    required: true,
                    shouldRowSpan: true,
                    width: 120,
                }, {
                    title: '随机病例数',
                    tebleItemKey: 'randomCaseNum',
                    type: 'InputNumber',
                    shouldRowSpan: true,
                    width: 100,
                }, {
                    title: '药物数量',
                    tebleItemKey: 'medicationNumberId',
                    showName: 'medicationNumberName',
                    type: 'Select',
                    required: true,
                    shouldRowSpan: true,
                    width: 100,
                    typeProperty: {
                        style: { width: '100%' },
                        option: medicationNumberOption,
                    }
                }, {
                    title: '给药途径',
                    tebleItemKey: 'routeName',
                    required: true,
                    type: 'text',
                    width: 80,
                }, {
                    title: '给药类别',
                    tebleItemKey: 'routeType',
                    required: true,
                    type: 'text',
                    width: 80,
                }, {
                    title: '药物名称',
                    tebleItemKey: 'drugName',
                    required: true,
                    type: 'text',
                    width: 80,
                }, {
                    title: '来院访视周期',
                    tebleItemKey: 'visitCycleShow',
                    required: true,
                    type: 'text',
                    className: 'header-blue',
                    width: 80,
                }, {
                    title: '来院用药频率(指的是患者来院访视用药)',
                    tebleItemKey: 'medicationCycleShow',
                    type: 'text',
                    width: 120,
                    className: 'header-orange',
                }, {
                    title: '治疗期来院用药次数',
                    tebleItemKey: 'medicationShow',
                    type: 'text',
                    width: 120,
                }, {
                    title: '静脉数',
                    tebleItemKey: 'veinNum',
                    type: 'text',
                    shouldRowSpan: true,
                    width: 80,
                }],
            },
        },

        {
            label: '预筛服务信息',
            type: 'Title',
        },
        {
            label: '是否跟台',
            name: 'isFollowTheStage',
            type: 'Select',
            show: true,
            isYseOrNo: true,
            required: true,
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '跟台小时数',
            name: 'followTheStageHour',
            type: 'InputNumber',
            show: isFollowTheStage == '1',
            unit: `小时 ${followTheStageDay} 天`,
            typeProperty: {
                style: { width: '84%' },
                precision: 2,
            },
        }, {
            label: '跟台天数',
            name: 'followTheStageDay',
            show: isFollowTheStage == '1',
            type: 'text',
            show: false,
            unit: '天',
        },  {
            label: '是否跟门诊',
            name: 'hasFollowTheClinic',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            show: true,
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '跟门诊小时数',
            name: 'followTheClinicHour',
            type: 'InputNumber',
            show: hasFollowTheClinic == '1',
            unit: `小时 ${followTheClinicDay} 天`,
            typeProperty: {
                style: { width: '84%' },
                precision: 2,
            },
        }, {
            label: '跟门诊天数',
            name: 'followTheClinicDay',
            show: hasFollowTheClinic == '1',
            type: 'text',
            show: false,
            unit: '天',
        },{
            label: '预筛服务中心数',
            name: 'preFilterServeSiteNum',
            type: 'InputNumber',
            show: canEditPreFilterHour,
            required: true,
        }, {
            label: '预筛周期',
            name: 'preFilterPeriod',
            type: 'InputNumber',
            show: canEditPreFilterHour,
            required: true,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
            unit: '月',
        }, {
            label: '每月单中心预筛小时数',
            name: 'singleSitePreFilterHour',
            type: 'InputNumber',
            show: canEditPreFilterHour,
            required: true,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
            unit: '小时',
        }, {
            label: '预筛工时',
            name: 'preFilterHour',
            type: 'InputNumber',
            show: canEditPreFilterHour,
            required: true,
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '预筛产出率预估',
            name: 'preFilterEstimationOutputRate',
            type: 'text',
            unit: '%',
        },

        // {
        //     label: '中心病例信息采集',
        //     type: 'Title',
        // },
        // {
        //     label: '协调病理切片等试验标本处理次数',
        //     name: 'coordinatePathologicalSectionsCount',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || pmlAuth || pmAuth || seniorUserAuth) && canEditCoordinatePathologicalSectionsCount,
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // },  {
        //     label: '是否涉及刻盘或上传',
        //     name: 'isNeedEngravingUpload',
        //     type: 'Select',
        //     required: true,
        //     isYseOrNo: true,
        //     typeProperty: {
        //         option: yseOrNo,
        //     },
        // }, {
        //     label: '每例刻盘或上传次数',
        //     name: 'engravingUploadCount',
        //     type: 'InputNumber',
        //     show: isNeedEngravingUpload == '1',
        //     required: true,
        // }, {
        //     label: '是否有密集PK采血',
        //     name: 'hasIntensivePkBlood',
        //     isYseOrNo: true,
        //     type: 'text',
        // }, {
        //     label: '密集PK采血的受试者例数',
        //     name: 'intensivePkBloodCount',
        //     show: hasIntensivePkBlood == '1',
        //     type: 'text',
        // }, {
        //     label: '每例受试者密集PK采血点次数',
        //     name: 'singlePatientIntensivePkBloodCount',
        //     show: hasIntensivePkBlood == '1',
        //     type: 'text',
        // }, {
        //     label: '每例病人影像信息资料(次数)',
        //     name: 'patientImageEvaluationCount',
        //     type: 'text',
        // },
        {
            label: '非盲服务',
            type: 'Title',
            show: canEditUnblindedAverageMonthFte || canEditUnblindedPmAverageMonthFte,
        },
        {
            label: '非盲CRC月均FTE',
            name: 'unblindedAverageMonthFte',
            type: 'InputNumber',
            show: canEditUnblindedAverageMonthFte,
            required: true,
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '非盲PM月均FTE',
            name: 'unblindedPmAverageMonthFte',
            type: 'InputNumber',
            show: canEditUnblindedPmAverageMonthFte,
            required: true,
            typeProperty: {
                precision: 2,
            },
        },
        {
            label: '其他信息',
            type: 'Title',
        },
        {
            label: '是否有夜班',
            name: 'hasNightShift',
            type: 'Select',
            isYseOrNo: true,
            typeProperty: {
                option: yseOrNo,
            },
        },
        {
            label: '项目访视例数统计',
            type: 'Title',
        },
        {
            label: '各访视方案下受试者访视次数',
            name: 'subjectsVisitsNumber',
            type: 'text',
        }, {
            label: '总计划完成例数',
            name: 'totalFinishCount',
            type: 'text',
        }, {
            label: '单病人标访数量(不包括计划外)',
            name: 'singlePatientStandardCount',
            type: 'text',
        }, {
            label: '每例受试者治疗周期',
            name: 'treatmentPeriod',
            type: 'text',
        }, {
            label: '每例受试者总访视次数(不包括计划外)',
            name: 'singlePatientTotalCount',
            type: 'text',
        }, {
            label: '每例受试者预筛访视次数',
            name: 'singlePatientPreFilterCount',
            type: 'text',
        }, {
            label: '每例受试者筛选访视次数',
            name: 'singlePatientFilterCount',
            type: 'text',
        }, {
            label: '每例受试者导入访视次数',
            name: 'singlePatientImportCount',
            type: 'text',
        }, {
            label: '每例受试者随机访视次数',
            name: 'singlePatientRandomCount',
            type: 'text',
        }, {
            label: '每例受试者治疗访视次数',
            name: 'singlePatientTreatCount',
            type: 'text',
        }, {
            label: '每例受试者非用药访视访视次数',
            name: 'singlePatientNonMedicineCount',
            type: 'text',
        }, {
            label: '每例受试者安全性随访次数',
            name: 'singlePatientSafeCount',
            type: 'text',
        }, {
            label: '每例受试者EOT访视次数',
            name: 'singlePatientEotCount',
            type: 'text',
        }, {
            label: '每例受试者电话随访次数',
            name: 'singlePatientPhoneCount',
            type: 'text',
        }, {
            label: '每例受试者计划外访视次数',
            name: 'singlePatientOutPlanCount',
            type: 'text',
        }, {
            label: '每例受试者回输次数',
            name: 'singlePatientFeedbackCount',
            type: 'text',
        }, {
            label: '项目总体标准访视数量',
            name: 'planStandardVisitAmount',
            type: 'text',
        }, {
            label: '计划筛选失败率',
            name: 'planFilterFailRate',
            type: 'text',
            unit: '%',
        }, {
            label: '预计受试者脱落率',
            name: 'estimatedSubjectSheddingRate',
            type: 'text',
            unit: '%',
        },
        {
            label: '受试者相关服务单价',
            type: 'Title',
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveResearchCycle,
        }, {
            label: '此业务线标准访视单价',
            name: 'productStandardVisitUnitPrice',
            type: 'text',
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveResearchCycle,
            unit: '元',
        }, {
            label: '此领域标准访视单价',
            name: 'areaStandardVisitUnitPrice',
            type: 'text',
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveResearchCycle,
            unit: '元',
        }, {
            label: '此疾病标准访视单价',
            name: 'diseaseStandardVisitUnitPrice',
            type: 'text',
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveResearchCycle,
            unit: '元',
        }, {   
            label: '参考标准访视单价',
            name: 'referenceStandardVisitUnitPrice',
            type: 'customize',
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveResearchCycle,
            required: true,
            customizeProperty: [
                {   
                    name: 'researchProductTypeId',
                    type: 'Cascader',
                    style: { width: 100 },
                    placeholder: '请选择研究产品类型',
                    option: researchProductTypeList,
                },
                {   
                    name: 'investigationAreaId',
                    type: 'Select',
                    style: { width: 100 },
                    showSearch: true,
                    allowClear: true,
                    placeholder: '请选择项目领域',
                    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
                    option: areaOption,
                },
                {   
                    name: 'diseaseClassId',
                    showName: 'diseaseClassName',
                    type: 'SearchRetrieve',
                    style: { width: 100 },
                    keyword: "diseaseClassName",
                    placeholder: "请选择疾病分类",
                    disabled: !investigationAreaId || investigationAreaId==='0',
                    params: {limit: 20, investigationAreaId: investigationAreaId ? investigationAreaId : undefined},
                    url: API_URL.common.queryDiseaseClassByAreaId,
                    config: { id: 'diseaseClassId', name: 'diseaseClassName'},
                    // extraOption: [{ label: '-', value: 0 }],
                },
                {   
                    name: 'diseaseId',
                    showName: 'diseaseName',
                    type: 'SearchRetrieve',
                    style: { width: 100 },
                    keyword: "keyword",
                    placeholder: "请选择疾病",
                    disabled: !diseaseClassId || diseaseClassId==='0' || !investigationAreaId || investigationAreaId==='0',
                    params: {limit: 20, investigationAreaId: investigationAreaId ? investigationAreaId : undefined, diseaseClassId: diseaseClassId ? diseaseClassId : undefined},
                    url: API_URL.common.queryAllDisease,
                    config: { id: 'diseaseId', name: 'diseaseName'},
                    // extraOption: [{ label: '-', value: 0 }],
                }
            ]
        }, {
            label: '此项目标准访视单价',
            name: 'standardVisitUnitPrice',
            type: 'InputNumber',
            disabled: true,
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveResearchCycle,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
                className: 'inputNumberDisabled',
            },
            unit: '元',
        },
        {
            label: '非试者相关服务单价',
            type: 'Title',
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveResearchCycle,
        }, 

        // {
        //     label: '启动阶段(FSA-LSA)单价(元/中心)',
        //     name: 'startPhaseUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showStartPhaseUnitPrice && haveResearchCycle,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, 
        {
            label: '入组阶段(FPI-LPI)单价(元/中心)',
            name: 'inGroupPhaseUnitPrice',
            type: 'InputNumber',
            show: (talAuth || deptBoAuth || seniorUserAuth) && showInGroupPhaseUnitPrice && haveResearchCycle,
            unit: '元',
            required: true,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
        }, {
            label: '治疗期单价(元/中心)',
            name: 'treatmentPeriodUnitPrice',
            type: 'InputNumber',
            show: (talAuth || deptBoAuth || seniorUserAuth) && showTreatmentPeriodUnitPrice && haveResearchCycle,
            unit: '元',
            required: true,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
        }, {
            label: '随访期单价(元/中心)',
            name: 'followUpPeriodUnitPrice',
            type: 'InputNumber',
            show: (talAuth || deptBoAuth || seniorUserAuth) && showFollowUpPeriodUnitPrice && haveResearchCycle,
            unit: '元',
            required: true,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
        }, {
            label: '关中心单价(元/中心)',
            name: 'closeSiteUnitPrice',
            type: 'InputNumber',
            show: (talAuth || deptBoAuth || seniorUserAuth) && showCloseSiteUnitPrice && haveResearchCycle,
            unit: '元',
            required: true,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
        }, {
            label: 'DBL单次访视小时数(小时/次)',
            name: 'dblUnitVisitHour',
            type: 'InputNumber',
            show: (talAuth || deptBoAuth || seniorUserAuth) && showDblUnitVisitHour && haveResearchCycle,
            unit: '小时/次',
            required: true,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
        }, {
            label: '项目管理单价',
            type: 'Title',
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveInvManagerServe,
        }, {
            label: 'PM管理费用占比',
            name: 'pmProjectManagerFtePercent',
            type: 'InputNumber',
            show: (talAuth || deptBoAuth || seniorUserAuth) && showPmProjectManagerFtePercent && haveInvManagerServe,
            required: true,
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
        }, {
            label: '中心快速启动服务单价',
            type: 'Title',
            show: (talAuth || deptBoAuth || seniorUserAuth) && haveSiteStartServe,
        }, {
            label: '启动服务单价(元/中心)',
            name: 'startSiteServeUnitPrice',
            type: 'InputNumber',
            show: (talAuth || deptBoAuth || seniorUserAuth) && showStartSiteServeUnitPrice && haveSiteStartServe,
            required: true,
            unit: '元',
            typeProperty: {
                precision: 2,
                style: { width: '75%'},
            },
        }, 
        
        // {
        //     label: '遗传办服务单价',
        //     type: 'Title',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && haveGeneticOfficeLead,
        // }, {
        //     label: '遗传办onsite-牵头单位单价(元/中心)',
        //     name: 'startGeneticLeadingUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showStartGeneticLeadingUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, {
        //     label: '遗传办onsite-非牵头单位单价(元/中心)',
        //     name: 'geneticNonLeadingUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showGeneticNonLeadingUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, {
        //     label: '采集审批单价(元)',
        //     name: 'collectAndApproveUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showCollectAndApproveUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, {
        //     label: '数据备份备案单价(元)',
        //     name: 'dataBackupFilingUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showDataBackupFilingUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, {
        //     label: '国际合作审批单价(元)',
        //     name: 'internationalCooperationApprovalUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showInternationalCooperationApprovalUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, {
        //     label: '国际合作备案单价(元)',
        //     name: 'internationalCooperationFilingUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showInternationalCooperationFilingUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, {
        //     label: '国际合作变更单价(元)',
        //     name: 'internationalCooperationChangesUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showInternationalCooperationChangesUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, {
        //     label: '材料出境审批单价(元)',
        //     name: 'materialExportApprovalUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showMaterialExportApprovalUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // }, {
        //     label: '保藏审批单价(元)',
        //     name: 'preservationApprovalUnitPrice',
        //     type: 'InputNumber',
        //     show: (talAuth || deptBoAuth || seniorUserAuth) && showPreservationApprovalUnitPrice && haveGeneticOfficeLead,
        //     unit: '元',
        //     required: true,
        //     typeProperty: {
        //         precision: 2,
        //         style: { width: '75%'},
        //     },
        // },  
    ];
        return Config
    }

    delTableRecord = (key, index, delRowNum) => {
        const { params } = this.state;
        params[key].splice(index, delRowNum);
        this.setState({ params });
    }

    showFeferenceQuote = () => {
        const { record } = this.props;
        this.FeferenceQuoteRef.show(record);
    }

    render() {
        const { params, type, submitDisabled } = this.state;
        const { showButn = true } = this.props;

        return (
            <div>
                { showButn &&
                    <div style={{ float: 'right' }}>
                        <Button type="primary" onClick={this.showFeferenceQuote}>参考评估</Button>
                    </div>
                }
                <FomeList 
                    params={params}
                    updateType={type}
                    handleChange={this.handleChange}
                    delTableRecord={this.delTableRecord}
                    handleTableChange={this.handleTableChange}
                    handleMedicationSituationChange={this.handleMedicationSituationChange}
                    DomConfig={this.handleDomRender()}
                />
                <FeferenceQuote ref={el => this.FeferenceQuoteRef = el} />
                <SubjectsVisitsNumber ref={el => this.SubjectsVisitsNumberRef = el} />
                {
                    showButn && <div className='Forecast_Params_footer'>
                    {
                        type === 'view'?
                        <Button 
                            type="primary"
                            onClick={() => this.setState({
                                type: 'edit',
                            })}
                        >编辑</Button> :
                        <div>
                            <Button 
                                style={{ marginRight: 20 }}
                                onClick={() => this.setState({
                                    type: 'view',
                                }, () => this.loadData(params.evaluateRecordId))}
                            >取消</Button>
                            <Button 
                                type="primary"
                                disabled={submitDisabled}
                                onClick={this.submit}
                            >确定</Button>
                        </div>
                    }
                </div>
                }
            </div>
            
            
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/ForecastParams.js